<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">
            <!-- 활성화된 링크에 active -->
            <a href="javascript:" class="active" v-if="isServiceBulletin || isLocalServiceBulletin">{{ pageTitle }} - {{ $t('BUTTON.GLOBAL.LIST') }}</a>
            <span v-if="!(isServiceBulletin || isLocalServiceBulletin)">{{ pageTitle }} - {{ $t('BUTTON.GLOBAL.LIST') }}</span>

            <a v-if="isHHPAvailable && isServiceBulletin" href="javascript:" class=""  @click="moveHHP($event)">
                Mobile (English)
            </a>
            <a v-if="isHHPAvailable && isLocalServiceBulletin" href="javascript:" class=""  @click="moveHHP($event)">
                Mobile (Other Languages)
            </a>
        </h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <knowledge-search
            v-if="getCondition !== null"
            :boardId="getBoardId"
            :condition="getCondition"
            @current-page="setCurrentPage"
        />
        <!-- //srchTop_wrap -->

        <!-- Grid -->
        <div v-if="isLoading"></div>
        <div v-else>
            <div class="grid_wrap" v-resize="setGridResizeColumn">
                <div v-show="getBoardCreationYN == 'Y'" class="btn_wrap">
                    <a v-if="erpNewBoardIds.includes(boardId)" href="javascript:" class="btn_white" @click="excelDownload">{{ $t('BUTTON.GLOBAL.EXCELDOWNLOAD') }}</a>
                    <a href="javascript:" class="btn_gray" :title="$t('BUTTON.GLOBAL.CREATE')" @click="createContents">{{ $t('BUTTON.GLOBAL.CREATE') }}</a>
                </div>
                <knowledge-list-grid
                    :gridId="gridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :pageOptions="pageOptions"
                    :click="contentClick"
                    :isTotalCount="true"
                    @grid-total-count="setTotalCount"
                />
            </div>
            <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="movePage"
                />
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>

<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import KnowledgeSearch                      from './KnowledgeSearch';
import KnowledgeListGrid                    from './KnowledgeListGrid';

import KnowledgeAttachFilePopup             from './popup/KnowledgeAttachFilePopup';
import KnowledgeASCHitCountPopup            from './popup/KnowledgeASCHitCountPopup';
import KnowledgeContentsPopup               from './popup/KnowledgeContentsPopup';

const fetchErpBoardIds = (menuDtlCd) => axios.post(
    `${SDLUtil.API_URL}/basis/eur/getBoardIdForErps.skp`,
    qs.stringify({ menuGrpDtlCd: menuDtlCd }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// list 에서 쓰이는 아이콘 이미지 경로
const ICON_IMG = {
    favorite:   { on: '/static/images/ico_favorite_on.png',     off: '/static/images/ico_favorite_off.png'},
    recommend:  { on: '/static/images/ico_like_on.png',         off: '/static/images/ico_like_off.png'},
    external:   { on: '/static/images/ico_link_on.png',        off: '/static/images/ico_link_off.png'},
    file:       { on: '/static/images/ico_attach.png',          off: ''}
};

// ToastGrid image icon renderer
class CustomImageRenderer {
    constructor(props) {
        const el = document.createElement('img'),
              em = document.createElement('em');
        const { imgType } = props.columnInfo.renderer.options;
        let onImg = '', offImg = '';

        // renderer by column type
        switch(imgType) {
            case 'favorite' : onImg = ICON_IMG.favorite.on,     offImg = ICON_IMG.favorite.off;     break;
            case 'external' : onImg = ICON_IMG.external.on,     offImg = ICON_IMG.external.off;     break;
            case 'recommend': onImg = ICON_IMG.recommend.on,    offImg = ICON_IMG.recommend.off;    break;
            case 'file'     : onImg = ICON_IMG.file.on,         offImg = ICON_IMG.file.off;         break;
            default         : break;
        };

        let isImg = false;
        if(!SDLUtil.isNull(props.value)) {
            if(props.value === 'Y' || props.value > 0 || props.value === true) isImg = true;
        }

        el.src = isImg ? onImg : offImg;
        if(imgType === 'recommend') {
            const div = document.createElement('div');
            div.appendChild(el);

            //if(props.value > 0) {
                em.className = 'like_count';
                em.setAttribute('data-val', props.value);
                // 숫자가 많아질 경우 -> K, M, B, T 단위 적용
                // em.innerText = StringUtil.formatToUnits((rops.value, 0);
                em.innerText = StringUtil.numberFormat(props.value);
                div.appendChild(em);
            //};

            this.el = div;

        } else {
            this.el = el;
        }
    }

    getElement() {
        return this.el;
    }
};

// ToastGrid subject renderer
class CustomTitleRenderer {
    constructor(props) {
        const el = document.createElement('div');
        el.className = "tui-grid-cell-content";

        const em = document.createElement('em'),
              imEm = document.createElement('em');

        let title = props.value || 'Untitled';

        // Read, Hot, New, Update
        if(title.indexOf('@R@') > -1) {
            em.className = "textbgbox_recommend";
            em.innerText = "R";
            title = title.replace('@R@', '');
            el.appendChild(em);

        } else if(title.indexOf('@H@') > -1){
            em.className = "textbgbox_hot";
            em.innerText = "H";
            title = title.replace('@H@', '');
            el.appendChild(em);

        } else if(title.indexOf('@N@') > -1){
            em.className = "textbgbox_new";
            em.innerText = "N";
            title = title.replace('@N@', '');
            el.appendChild(em);

        } else if(title.indexOf('@U@') > -1){
            em.className = "textbgbox_update";
            em.innerText = "U";
            title = title.replace('@U@', '');
            el.appendChild(em);
        }

        // Important, Must Read
        if(title.indexOf('@I@') > -1) {
            imEm.className = "textcolor_important";
            imEm.innerText = "["+ SDLUtil.getMsgProp('FIELD.GLOBAL.IMPORTANT') +"]";
            title = title.replace('@I@', '');
            title = title.replace('@M@', '');   // Important, Must Read 중복 방지
            el.appendChild(imEm);

        } else if(title.indexOf('@M@') > -1) {
            imEm.className = "textcolor_must";
            imEm.innerText = "["+ SDLUtil.getMsgProp('FIELD.GLOBAL.MUSTREAD') +"]";
            title = title.replace('@M@', '');
            el.appendChild(imEm);
        }
        title = SDLUtil.convertHtml(title);

        el.appendChild(document.createTextNode(title));

        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

export default {
    name : 'KnowledgeList',
    props : {
        boardId: { required: true }
    },
    data() {
        return {
            isLoading: true,
            condition: null,
            pageTitle: '',

            // Only title active class
            selectedMode: 'HHP',
            isHHPAvailable: false,

            erpNewBoardIds: [],

            headerList: [],

            gridId: 'grid_' + String(this.boardId),
            columns: [],
            options: {},
            pageOptions: {},
            gridData:  [],
            searchFormData: {},

            // Prevent grid click event
            rtnCols: ['FAVORITE', 'RECOMMEND', 'ATTACH_CNT','HIT_COUNT'],
            // AS-IS Knowledge.xml line 1327 - ORDER BY surported
            sortableCols: [
                'MODEL', 'PRD_CATEGORY_CD1', 'PRD_CATEGORY_CD2', 'PRD_CATEGORY_CD3',
                'KNOWLEDGE_TITLE', 'REG_USER_NO', 'REG_DT', 'MODF_DT', 'CHANNEL', 'HIT_COUNT'
            ],
            // AS-IS ListSearch.jsp line 353 - BoardId for ASC account no popup list
            boardListForHitsPopup: [
                '8248','9242','9243','9244','9245','9248','9249','9251','9287','10205','10208','13156','13258','13160','13162','8235'
            ],

            totalCount: 0,
            currentPage: 1,
            perPage: 20 // knowledgeManager fix
        }
    },
    directives: { resize },
    computed: {
        ...mapGetters({
            params: 'getParams',
            userCorpCd: 'getCorpCd',
            userRoles: 'getRoles',
        }),
        getIcon() {
            return this.icon;
        },
        getBoardId() {
            return this.boardId;
        },
        getCondition() {
            return this.condition;
        },
        getUserRole() {
            return this.userRoles || [];
        },
        getBoardCreationYN() {
            return this.params.creationYn || 'N';
        },
        //Get userCorpCdCode , if 'C820','C390' can use external sharing function. ke01.liu 2022-07-22
        getUserCorpCd(){
        	let userCorpCode = this.userCorpCd  || '';
        	if(['C820','C390'].includes(userCorpCode)){
                 return true;
            } else {
                 return false;
            }
        },
        //Get MenuGrpDetailCode , if ['KSML','KRTT','KSBL','TM'] can use external sharing function. ke01.liu 2022-07-22
        getMenuGrpDetailCd() {
            let menuGrpDetailCode = this.params.menuGrpDetailCd  || '';
        	if(['KSML','KRTT','KSBL','TM'].includes(menuGrpDetailCode)){
                 return true;
            } else {
                 return false;
            }
        },
        // Service Bulletin check
        isServiceBulletin(){
            // Service Bulletin & HHP & Pc Only
            /*
             * HHP Service Bulletin English         : /basis/anysvcmobile/svcBulletin/sbList
             * HHP Service Bulletin Other Language  : /basis/anysvcmobile/svcBulletin/sbOtherList
             */
            if(['SB'].includes(this.params.menuGrpDetailCd)) {
                return true;
            } else {
                return false;
            }
        },
        // Service Bulletin check
        isLocalServiceBulletin(){
            // Service Bulletin & HHP & Pc Only
            /*
             * HHP Service Bulletin English         : /basis/anysvcmobile/svcBulletin/sbList
             * HHP Service Bulletin Other Language  : /basis/anysvcmobile/svcBulletin/sbOtherList
             */
            if(['KSBL'].includes(this.params.menuGrpDetailCd)) {
                return true;
            } else {
                return false;
            }
        },
    },
    components: {
        'knowledge-list-grid'   : KnowledgeListGrid,
        'sdl-pagination'        : SDLPagination,
        'skp-breadcrumbs'       : SKPBreadcrumbs,
        'knowledge-search'      : KnowledgeSearch
    },
    methods: {
        initLoad() {
            SDLUtil.showLoadingBar(true);
            const params = {
                BOARD_ID: this.getBoardId,
            };
            return SDLUtil.postForm(`/basis/knowledge/getListKnowledgeHeader.skp`, params)
                .then(data => {
                    Vue.$log.info('▶ KnowledgeList.vue initLoad grid response => ', data);
                    let headers = data.header.rowData || [];
                    let cond = data.condition.rowData || [];

                    this.headerList = headers;
                    this.columns = this.getDynamicCols();

                    return {
                        condition: cond[0],
                        BOARD_ID: data.BOARD_ID
                    };
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            let headers = this.headerList || [], headerList = [];
            // 접속 Device가 모바일 유형인 경우, 제목과 첨부파일로만 헤더 설정
            if( SDLUtil.isMobile() ) {
                // mobile
                if(headers.length > 0) {
                    headers = _.sortBy(headers, ['HEADER_ORDER']);
                    for(let header of headers) {
                        if(header.HEADER_COLUMN == 'KNOWLEDGE_TITLE') {
                            headerList.push({
                                header: header.HEADER_NAME,
                                name: header.HEADER_COLUMN,
                                align: header.HEADER_ALIGN,
                                ellipsis: true,
                                width: this.getMobColumnSize(100),
                                renderer: { type: CustomTitleRenderer }
                            });

                            break;
                        }
                    };

                    // 첨부파일
                    headerList.push({
                        header: ' ', name: 'ATTACH_CNT', align: 'center', width: 80,
                        renderer: { type: CustomImageRenderer, options: { imgType : 'file' } }
                    });
                };

            // 그 외
            } else {
                // desktop, tablet
                if(headers.length > 0) {
                    // 즐겨찾기
                    headerList.push({
                        header: ' ', name: 'FAVORITE', align: 'center', width: 50, sortable: true,
                        renderer: { type: CustomImageRenderer, options: { imgType : 'favorite' } }
                    });

                    // External sharing   2022-07-20 ke01.liu
                    if(this.getMenuGrpDetailCd && this.getUserCorpCd){
	                    headerList.push({
	                        header: ' ', name: 'EXTERNAL_SHARE', align: 'left', width: 30, sortable: false,
	                        renderer: { type: CustomImageRenderer, options: { imgType : 'external' } }
	                    });
                    }

                    // 좋아하는 컨텐츠
                    headerList.push({
                        header: ' ', name: 'RECOMMEND', align: 'center', width: 50, sortable: true,
                        renderer: { type: CustomImageRenderer, options: { imgType : 'recommend' } }
                    });

                    // 모델
                    headerList.push({
                        header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'),
                        name: 'MODEL', align: 'center', width: 140, resizable: true, sortable: true
                    });

                    // 헤더 for loop
                    headers = _.sortBy(headers, ['HEADER_ORDER']);
                    for(let header of headers) {
                        // 헤더 컬럼이 DISPLAY_YN 인 경우, 권한 체크
                        if(header.HEADER_COLUMN == 'DISPLAY_YN') {
                            if(
                                // Admin 유저 전용 컬럼
                                this.getUserRole.find(
                                    r => r === `${constants.SYSTEM_ADMIN}`
                                      || r === `${constants.GBM_ADMIN}`
                                      || r === `${constants.RHQ_ADMIN}`
                                      || r === `${constants.SUB_ADMIN}`
                                )
                            ) {
                                headerList.push({
                                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DISPLAY'),
                                    name: header.HEADER_COLUMN,
                                    align: header.HEADER_ALIGN,
                                    width: this.getColumnSize(header.HEADER_WIDTH),
                                    resizable: true,
                                    sortable: true
                                });
                            }

                        } else {
                            let returnCols = this.rtnCols,
                                includeBoardNo = false,
                                isTitle = false;

                            // 헤더 컬럼에 따라 이벤트 분기
                            if(header.HEADER_COLUMN == 'HIT_COUNT') {
                                // 클릭 이벤트 컬럼 재정의 (기본 컬럼 + HIT_COUNT)
                                if(this.boardListForHitsPopup.find( b => b === this.boardId )) {
                                    returnCols.push(header.HEADER_COLUMN);
                                    this.rtnCols = returnCols;
                                    includeBoardNo = true;
                                }

                            } else if(header.HEADER_COLUMN == 'KNOWLEDGE_TITLE') {
                                isTitle = true;
                            }

                            headerList.push({
                                header: header.HEADER_NAME,
                                name: header.HEADER_COLUMN,
                                align: header.HEADER_ALIGN,
                                width: this.getColumnSize(header.HEADER_WIDTH),
                                className: includeBoardNo ? 'ftColor' : '',
                                resizable: true,
                                sortable: _.includes(this.sortableCols, header.HEADER_COLUMN) ? true : false,
                                renderer: isTitle ? { type: CustomTitleRenderer } : null
                            });
                        }
                    };

                    // 첨부파일
                    headerList.push({
                        header: ' ', name: 'ATTACH_CNT', align: 'center', width: 80, resizable: true,
                        renderer: { type: CustomImageRenderer, options: { imgType : 'file' } }
                    });
                };
            };

            return headerList;
        },
        getMobColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 80) / (100 / size));
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 310) / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('knowledge-grid-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        // 페이지 이동
        movePage(pageNo) {
            // EventBus 를 통해 이벤트를 호출한다. 해당 이벤트는 KnowledgeSearch.vue 에서 응답한다.
            EventBus.$emit('knowledge-page-search', pageNo);
            this.currentPage = pageNo;
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            this.totalCount = totCnt;
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            this.currentPage = page;
        },
        // 컨텐츠 클릭 이벤트 -> KnowledgeListGrid
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let knowledgeId = row['KNOWLEDGE_ID'] || '';

            // 컬럼별 이벤트 실행
            if (this.rtnCols.find(c => c === colNm)) {
                // Attach event
                if(colNm === 'ATTACH_CNT') {
                    let attachCnt = row['ATTACH_CNT'] || 0;
                    if(attachCnt > 0) {
                        SDLUtil.show(
                            KnowledgeAttachFilePopup,
                            {
                                title: SDLUtil.getMsgProp('FIELD.GLOBAL.ATTACH.FILE'), // Attach Files
                                knowledgeId: knowledgeId,
                            },  // component params
                            {
                                height: 'auto'
                            }   // dialog params
                        );
                    }
                // External sharing ke01.liu 2022-07-20
//                 } else if (colNm === 'EXTERNAL_SHARE'){
//                 	let cVal = 0,
// 	                    imgEl = document.createElement('img'),
// 	                    url = '', fvParams = { workCd: MenuUtil.getScrapWorkCode(), workCdSeq: knowledgeId };
// 	                if( row['EXTERNAL_SHARE'] === 'Y' ) {
// 	                    imgEl.src = ICON_IMG.external.on, cVal = 0;
// 	                    url = `${SDLUtil.API_URL}/basis/common/scrap/deleteScrap.skp`;
// 	                } else {
// 	                    imgEl.src = ICON_IMG.external.off, cVal = 1;
// 	                    url = `${SDLUtil.API_URL}/basis/common/scrap/scrap.skp`;
// 	                }

// 	                return  axios.post( url, qs.stringify(fvParams), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
// 	                        .then(res => {
// 	                            let msg = "";
// 	                            if(cVal > 0) {
// 	                                msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.ADDFAVORITE');
// 	                            } else {
// 	                                msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.REMOVEFAVORITE');
// 	                            }
// 	                            // Notification
// 	                            Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );

// 	                            EventBus.$emit('knowledge-grid-change-column-element', { rowNo: e.rowKey, colNm: colNm, cEl: imgEl });
// 	                            grid.invoke('setValue', e.rowKey, 'FAVORITE', cVal, false);
// 	                        })
// 	                        .catch(err => {
// 	                            SDLUtil.errorAlert(err);
// 	                        });

                // Favorite event
                } else if(colNm === 'FAVORITE') {
                    let cVal = 0,
                        imgEl = document.createElement('img'),
                        url = '', fvParams = { workCd: MenuUtil.getScrapWorkCode(), workCdSeq: knowledgeId };
                    if( row['FAVORITE'] > 0 ) {
                        imgEl.src = ICON_IMG.favorite.off, cVal = 0;
                        url = `${SDLUtil.API_URL}/basis/common/scrap/deleteScrap.skp`;
                    } else {
                        imgEl.src = ICON_IMG.favorite.on, cVal = 1;
                        url = `${SDLUtil.API_URL}/basis/common/scrap/scrap.skp`;
                    }

                    return  axios.post( url, qs.stringify(fvParams), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
                            .then(res => {
                                let msg = "";
                                if(cVal > 0) {
                                    msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.ADDFAVORITE');
                                } else {
                                    msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.REMOVEFAVORITE');
                                }
                                // Notification
                                Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );

                                EventBus.$emit('knowledge-grid-change-column-element', { rowNo: e.rowKey, colNm: colNm, cEl: imgEl });
                                grid.invoke('setValue', e.rowKey, 'FAVORITE', cVal, false);
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });

                // Recommend event
                } else if(colNm === 'RECOMMEND') {
                    /*
                    let cVal = 0, imgEl = document.createElement('img'),
                        url = '', fvParams = { workCd: MenuUtil.getScrapWorkCode(), workCdSeq: knowledgeId };
                    // 추천 이벤트는 없을 때만 동작, once event
                    if( row['RECOMMEND'] == 0 ) {
                        imgEl.src = ICON_IMG.recommend.on;
                        url = `${SDLUtil.API_URL}/basis/common/scrap/recommend.skp`;
                        return  axios.post( url, qs.stringify(fvParams), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
                            .then(res => {
                                // Notification
                                Vue.toasted.show( SDLUtil.getMsgProp('MESSAGE.GLOBAL.RECOMMEND'), { theme: "toasted-primary", position: "top-center", duration : 3000 } );

                                EventBus.$emit('knowledge-grid-change-column-element', { rowNo: e.rowKey, colNm: colNm, cEl: imgEl });
                                grid.invoke('setValue', e.rowKey, 'RECOMMEND', 1, false);
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                    }*/
                    // 2020.05.25 Event close

                // Hit count evnet
//                 } else if( colNm === 'HIT_COUNT' ) {

//                   if(knowledgeId !== null) {
//                         SDLUtil.show(
//                             KnowledgeASCHitCountPopup,
//                             { title: SDLUtil.getMsgProp('FIELD.GLOBAL.ASC_CODE'), boardId: this.getBoardId, knowledgeId: knowledgeId },
//                             { height: 'auto' }
//                         );
//                     }
            	} else if( colNm === 'HIT_COUNT' && knowledgeId !== null) {

		       		if(this.boardListForHitsPopup.find( b => b === this.boardId )) {
		       			SDLUtil.show(
		       				KnowledgeASCHitCountPopup,
		       				{ title: SDLUtil.getMsgProp('FIELD.GLOBAL.ASC_CODE'), boardId: this.getBoardId, knowledgeId: knowledgeId },
		       				{ height: 'auto' }
		       			);
		       		}
            	}

            // default event -> call detail page
            } else {
                if(knowledgeId !== null) {
                    window.scrollTo(0, 0);
                    const params = {
                        KNOWLEDGE_ID: knowledgeId,
                        boardId: this.boardId
                    };

                    return this.$router.push({ path: 'knowledgeDetail', query: params });
                }
            }
        },
        // 컨텐츠 생성 팝업
        createContents() {
            store.commit('POPUP_PARAMS', {
                title: this.pageTitle,
                boardId: this.getBoardId,
                boardType1: this.params.menuPid,
                boardType2: this.params.menuId,
            });

            let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
            const detailPop = SDLUtil.openLegacyWindowPopup({
                url: linkUrl,
                title: this.pageTitle,
                w: 1366,
                h: 768
            });

            // 팝업이 닫히면 자동으로 리스트로 이동
            let self = this,
                popTimer = window.setInterval(function() {
                if (detailPop.closed !== false) { // !== is required for compatibility with Opera
                    window.clearInterval(popTimer);
                    EventBus.$emit('knowledge-page-search', 1);
                }
            }, 200);
         },
        moveKnowledge(ev) {
            this.switchMode('KNOW');

        },
        moveHHP(ev) {
            this.switchMode('HHP');

            let pathName = 'hhpServiceBulletin';

            if (this.params.menuGrpDetailCd === 'SB') {
                localStorage.setItem('sbBoardId', String(this.getBoardId));

            } else if (this.params.menuGrpDetailCd === 'KSBL') {
                localStorage.setItem('sbOtherBoardId', String(this.getBoardId));
                pathName = 'hhpServiceBulletinOther';
            }

            this.$router.push({
                name: pathName,
            });
        },
        switchMode(mode) {
            this.selectedMode = mode;
        },
        checkHHP() {
            return SDLUtil.getRequest('/basis/certificate/CertLogin.skp')
                .then(data => {
                    if (typeof data.pinYN !== 'undefined') {
                        this.isHHPAvailable = data.pinYN === 'Y' || data.loginYN === 'Y';
                    }
                })
                .catch(err => {
                    if (err.data.error.code === 'HHP_LOGIN_REQUIRED') {
                        this.isHHPAvailable = true;
                    } else {
                        Vue.$log.error('checkHHP', err);
                    }
                    return err;
                });
        },
        excelDownload() {
            if (this.totalCount === 0) {
            } else {
                EventBus.$emit('knowledge-excel-download', 1);
            }
        },
    },
    created() {
        /**
         * 권한 없는 유저가 들어올 때, 권한 없음 표시 필요
         */
        this.initLoad()
            .then((initObj) => {
                let initBoardId = initObj.BOARD_ID || "";
                if(SDLUtil.isNull(initBoardId)) {
                    SDLUtil.alert({
                        msg: 'MESSAGE.DATA.FIND.NODATA',
                        okLabel: 'BUTTON.GLOBAL.CONFIRM',
                        onOkEvt: () => {
                            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/main` });
                        }
                    });
                };

                // initialized function
                if(initObj.condition !== null) {
                    this.condition = initObj.condition;
                    this.isLoading = false;
                };

                /*
                if(initObj.headerList !== null) {
                    this.columns = initObj.headerList;
                    this.isLoading = false;
                }
                */

                SDLUtil.showLoadingBar(false);
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
                SDLUtil.showLoadingBar(false);
            });

        this.checkHHP();
    },
    mounted() {
        this.$nextTick(() => {
            // 200506 컨텐츠 상세에서 뒤로가기를 하였을 경우, 하단 추천 팝업이 사라지지 않음 -> 강제로 숨김 처리 이벤트 실행
            EventBus.$emit('knowledge-recommend-hide');
        });

        // 2020.11.06 김남갑 추가
        fetchErpBoardIds().then(res => {
            res.data.forEach(board => {
                this.erpNewBoardIds.push(board.BOARD_ID);
            });
            this.erpNewBoardIds.push('8673');
            this.erpNewBoardIds.push('8660');
            this.erpNewBoardIds.push('11130');
        }).catch( err => {
            SDLUtil.errorAlert(err);
        });

        Vue.$log.info("▶ KnowledgeList.vue mounted() => [BoardID] : ", this.getBoardId, ", [Page Name] : ", this.pageTitle
                , ", [Menu Group Cd] : ", store.getters.getParams.menuGrpCd, ", [Menu Scrap Cd] : ", MenuUtil.getScrapWorkCode());
    }
};
</script>

<style>
.bgColor { background-color: #DCF0FF }
.ftColor { color: dodgerblue!important; font-weight: bold!important; }
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/KnowledgeList.vue